import { FC, useState } from 'react';
import { IoCopyOutline } from 'react-icons/io5';
import { PiWhatsappLogo } from 'react-icons/pi';
import { WhatsappShareButton } from 'react-share';
import styled from 'styled-components';

import { Environment } from '../../constants/environments';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import { SimpleEvent } from '../../hooks/contexts/resaleEvent.context';
import * as Styles from '../ShareEvent/styles.share';
import Tooltip from '../Tooltip';

const WhatsAppShareButton = styled(WhatsappShareButton)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

type ShareResaleEventProps = {
  event: SimpleEvent;
};

const ShareResaleEvent: FC<ShareResaleEventProps> = ({ event }) => {
  const { translate } = useI18nContext();
  const [showTooltip, setShowTooltip] = useState(false);

  const shareUrl = `${Environment.INGRESSE_URL}/${event?.slug}`;

  const onClickCopyEvent = () => {
    setShowTooltip(true);
    navigator?.clipboard?.writeText(shareUrl);
  };

  return (
    <Styles.Wrapper id="share-resale-event-wrapper">
      <WhatsAppShareButton
        windowWidth={window.innerWidth}
        windowHeight={window.innerHeight}
        data-testid="whatsapp-share-button-resale-page"
        url={shareUrl}
        title={`${event?.title} -`}
      >
        <Styles.Background>
          <PiWhatsappLogo size="32px" color='#454F5B' />
        </Styles.Background>
        <Styles.Text>{translate(['SHARE_EVENT', 'WHATSAPP'])}</Styles.Text>
      </WhatsAppShareButton>

      <Styles.Grouper onClick={onClickCopyEvent} data-testid="copy-button-resale-page">
        {showTooltip &&
          <Tooltip message={translate(['SHARE_EVENT', 'COPIED'])} data-testid="tooltip-resale-page" />
        }
        <Styles.Background>
          <IoCopyOutline size="32px" color='#454F5B' />
        </Styles.Background>
        <Styles.Text>{translate(['SHARE_EVENT', 'COPY'])}</Styles.Text>
      </Styles.Grouper>

    </Styles.Wrapper>
  );
};

export default ShareResaleEvent;
